<template>
  <v-stepper width="600"  v-model="step" class="rpd-stepper mx-auto mt-2" :elevation="0" vertical>
    <v-stepper-step class="pb-4 pt-4" editable step="1" :complete="step > 1">
      Scheme Info
    </v-stepper-step>
    <v-stepper-content step="1">
      <form>
        <v-row>
          <v-col cols="8">
            <v-text-field
              outlined
              dense
              hide-details
              v-model="form.name"
              v-validate="'required|min:1'"
              :error-messages="errors.collect('form.name')"
              label="Scheme Name"
              data-vv-name="form.name"
              data-vv-as="Name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
            outlined
              dense
              hide-details
              v-model="form.type"
              :items="schemeTypes"
              label="Type"
              required
              :menu-props="{
                    offsetY: true,
                }"
              v-validate="'required'"
              :error-messages="errors.collect('form.type')"
              data-vv-name="form.type"
              data-vv-as="Type"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-text-field
            outlined
              dense
              hide-details
              v-model="form.opened_at"
              v-validate="''"
              :error-messages="errors.collect('form.opened_at')"
              label="Opened (Year)"
              data-vv-name="form.opened_at"
              data-vv-as="Opened"
              type="text"
              v-mask="'####'"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
            outlined
              dense
              hide-details
              v-model="form.car_spaces"
              v-validate="'min_value:0'"
              :error-messages="errors.collect('form.car_spaces')"
              label="Car Spaces"
              data-vv-name="form.car_spaces"
              data-vv-as="Car Spaces"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-checkbox
              v-model="form.is_under_construction"
              label="Under Construction?"
              required
              hide-details
              class="mt-0 pt-0"
            ></v-checkbox>
          </v-col>
        </v-row>
      </form>
      <!--<v-card color="grey lighten-1" class="mb-12" height="200px"></v-card>-->
      <v-btn class="mt-6" color="primary" @click="step = 2">Continue</v-btn>
    </v-stepper-content>

    <v-stepper-step class="pb-4 pt-4" editable step="2" :complete="step > 2">
      Add Address
    </v-stepper-step>
    <v-stepper-content step="2">
      <form>
        <v-row>
          <v-col cols="6">
            <v-text-field
            outlined
              dense
              hide-details
              v-model="form.address.street"
              v-validate="''"
              :error-messages="errors.collect('form.address.street')"
              label="Street"
              data-vv-name="form.address.street"
              data-vv-as="Street"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
            outlined
              dense
              hide-details
              v-model="form.address.street2"
              v-validate="''"
              :error-messages="errors.collect('form.address.street2')"
              label="Street 2 (Optional)"
              data-vv-name="form.address.street2"
              data-vv-as="Street 2"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
            outlined
              dense
              hide-details
              v-model="form.address.city"
              v-validate="''"
              :error-messages="errors.collect('form.address.city')"
              label="City"
              data-vv-name="form.address.city"
              data-vv-as="City"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
            outlined
              dense
              hide-details
              v-model="form.address.region"
              v-validate="''"
              :error-messages="errors.collect('form.address.region')"
              label="Region"
              data-vv-name="form.address.region"
              data-vv-as="Region"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
            outlined
              dense
              hide-details
              v-model="form.address.post_code"
              v-validate="''"
              :error-messages="errors.collect('form.address.post_code')"
              label="Post Code"
              data-vv-name="form.address.post_code"
              data-vv-as="Post Code"
            ></v-text-field>
          </v-col>

        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
            outlined
              dense
              hide-details
              v-model="form.address.country"
              :items="countries"
              cache-items
              flat
              hide-no-data
              item-text="name"
              item-value="name"
              label="Country"
              v-validate="''"
              :error-messages="errors.collect('form.address.country')"
              data-vv-name="form.address.country"
              data-vv-as="Country"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-textarea
                outlined
                dense
                hide-details  
                v-model="form.address.notes"
                v-validate="''"
                :error-messages="errors.collect('form.address.notes')"
                label="Notes"
                data-vv-as="Notes"
                data-vv-name="form.address.notes"
                auto-grow
                rows="1"
              ></v-textarea>
          </v-col>
        </v-row>
        
      </form>
      <v-btn class="mt-6" color="primary" @click="step = 3">Continue</v-btn>
    </v-stepper-content>

    <v-stepper-step class="pb-4 pt-4" step="3" editable>
      Add Contacts
    </v-stepper-step>
    <v-stepper-content step="3">
      <form>
        <v-row>
          <v-col cols="6">
            <v-autocomplete
            outlined
              dense
              hide-details
              v-model="form.landlords"
              :loading="landlords.loading"
              :items="landlords.items"
              :search-input.sync="landlords.search"
              cache-items
              chips
              multiple
              flat
              hide-no-data
              clearable
              item-text="name"
              item-value="id"
              label="Landlords"
              v-validate="''"
              :error-messages="errors.collect('form.landlords')"
              data-vv-name="form.landlords"
              data-vv-as="Landlords"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
            outlined
              dense
              hide-details
              v-model="form.landlord_contacts"
              :loading="landlordContacts.loading"
              :items="landlordContacts.items"
              :search-input.sync="landlordContacts.search"
              cache-items
              chips
              multiple
              flat
              hide-no-data
              clearable
              item-text="name"
              item-value="id"
              label="Landlord Contacts"
              v-validate="''"
              :error-messages="errors.collect('form.landlord_contacts')"
              data-vv-name="form.landlord_contacts"
              data-vv-as="Landlord Contacts"
            ></v-autocomplete>
            </v-col>
            <v-col cols="6">
            <v-autocomplete
            outlined
              dense
              hide-details
              v-model="form.landlord_agents"
              :loading="landlordAgents.loading"
              :items="landlordAgents.items"
              :search-input.sync="landlordAgents.search"
              cache-items
              chips
              multiple
              flat
              hide-no-data
              clearable
              item-text="name"
              item-value="id"
              label="Landlord Agents"
              v-validate="''"
              :error-messages="errors.collect('form.landlord_agents')"
              data-vv-name="form.landlord_agents"
              data-vv-as="Landlord Agents"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              outlined
              dense
              hide-details
              v-model="form.landlord_agent_contacts"
              :loading="landlordAgentContacts.loading"
              :items="landlordAgentContacts.items"
              :search-input.sync="landlordAgentContacts.search"
              cache-items
              chips
              multiple
              flat
              hide-no-data
              clearable
              item-text="name"
              item-value="id"
              label="Landlord Agent Contacts"
              v-validate="''"
              :error-messages="errors.collect('form.landlord_agent_contacts')"
              data-vv-name="form.landlord_agent_contacts"
              data-vv-as="Landlord Agent Contacts"
            ></v-autocomplete>
          </v-col>
        </v-row>
        
      </form>
      <v-btn class="mt-6" color="primary" @click="submit">Create Scheme</v-btn>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
import {mask} from 'vue-the-mask'
import countries from '@/data/countries.json'

export default {
  directives: {
    mask,
  },
  data: () => ({
    countries: countries,
    step: 1,
    schemeTypes: [
      'Leisure',
      'Out of town',
      'Shopping centres',
    ],
    landlordContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgentContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlords: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgents: {
      loading: false,
      items: [],
      search: null,
    },
    form: {
      name: '',
      type: null,
      opened_at: '',
      is_under_construction: false,
      car_spaces: '',
      landlords: [],
      landlord_contacts: [],
      landlord_agents: [],
      landlord_agent_contacts: [],
      address: {
        street: '',
        street2: '',
        city: '',
        region: '',
        post_code: '',
        country: 'United Kingdom',
        notes: '',
      },
    }
  }),
  watch: {
    'landlords.search'(search) {
      this.getCompanies(search);
    },
    'landlordContacts.search'(search) {
      this.getUsers(search);
    },
    'landlordAgents.search'(search) {
      this.getCompanies(search);
    },
    'landlordAgentContacts.search'(search) {
      this.getUsers(search);
    },

    "form.landlord_contacts"(val) {
      console.log(val)
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.landlords.find(company => company.id === contact.company_id)) {
            this.form.landlords.push(contact.company.data);
          }
        });
      }
    },

    "form.landlord_agent_contacts"(val) {
      console.log(val)
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.landlord_agents.find(company => company.id === contact.company_id)) {
            this.form.landlord_agents.push(contact.company.data);
          }
        });
      }
    },
  },
  computed: {
    formValidated() {
      return Object.keys(this.fields).some(key => this.fields[key].validated) &&
        Object.keys(this.fields).some(key => this.fields[key].valid)
    }
  },
  methods: {
    async getCompanies(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.landlords.items = response.data.data;
      this.landlordAgents.items = response.data.data;
    },
    async getUsers(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
          include: "company",
        }
      });
      this.landlordContacts.items = response.data.data;
      this.landlordAgentContacts.items = response.data.data;
    },
    async submit() {
      if (await this.$formValidator.validate(this.form)) {
        try {
          await this.$http.post('/schemes', this.form)
          this.$router.push('/schemes')
        } catch (e) {
          this.$validationException(e)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
